import React, { useMemo, useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import cx from "classnames";
import DynamicForm from "../common/DynamicForm";
import { GET_MAX_FILE_SIZE_FROM_DICT } from "constants/index";
import Loader from "../common/Loader";
import baseService from "services/BaseService";

const CustomerForm = props => {
    const { t, disabled = false, customerType, formColumns, isForceHiddenController } = props;

    const [dynParams, setDynParams] = useState({});
    const [isDynParamsLoading, setDynParamsIsLoading] = useState({});

    const maxFileSize = useMemo(() => GET_MAX_FILE_SIZE_FROM_DICT("form"), []);

    async function fetchDynamicFields(entity, objectTypeId, objectTypeCode, ctxObjectType, ctxObjectId, formKey) {
        setDynParamsIsLoading(prev => ({ ...prev, [formKey]: true }));
        if (isDynParamsLoading[formKey]) {
            return;
        }
        const data = {
            objectType: `${entity}@spec`,
            objectTypeId,
            objectTypeCode,
            openMode: "create",
            ctxObjectType,
            ctxObjectId,
            curStepNum: 1,
            overrideIsReq: "",
        };
        try {
            const response = await baseService.get("appeal_form_params", { data });
            if (response && response.success && response.result && response.result.blocks) {
                setDynParams(prev => ({ ...prev, [formKey]: response.result.blocks }));
            } else {
                console.error("CustomerForm::fetchDynamicFields: Request is failed.");
            }
        } catch (e) {
            console.error("CustomerForm::fetchDynamicFields: Error: ", e);
        } finally {
            setDynParamsIsLoading(prev => ({ ...prev, [formKey]: false }));
        }
    }

    function renderFormColumnBlock(block) {
        const { key, formKey, type, form, entity, component } = block;
        if (type === "static-form") {
            return (
                <div className="static-form-container">
                    <DynamicForm
                        t={t}
                        formName={formKey}
                        dynData={form}
                        maxFileSize={maxFileSize}
                        isForceHiddenController={isForceHiddenController}
                        withoutLiveSaver
                    />
                </div>
            );
        }
        if (type === "dynamic-form") {
            const isLoading = isDynParamsLoading[formKey];
            const dynData = dynParams[formKey];
            return (
                <div className={cx("dynamic-form-container", { "is-loading": isLoading })}>
                    {isLoading && <Loader />}
                    {dynData && (
                        <DynamicForm
                            t={t}
                            formName={formKey}
                            dynData={dynData}
                            maxFileSize={maxFileSize}
                            isForceHiddenController={isForceHiddenController}
                            withoutLiveSaver
                        />
                    )}
                </div>
            );
        }
        if (type === "component") {
            return <div className="static-form-container">{component}</div>;
        }
        return null;
    }

    function renderFormColumn(column) {
        return <div className="create-new-customer-form-column">{column.map(renderFormColumnBlock)}</div>;
    }

    useEffect(() => {
        const dynBlocks = formColumns.flatMap(column => column.filter(block => block.type === "dynamic-form"));
        dynBlocks.forEach(block => {
            const { entity, objectTypeId, objectTypeCode, ctxObjectType, ctxObjectId, formKey } = block;
            fetchDynamicFields(entity, objectTypeId, objectTypeCode, ctxObjectType, ctxObjectId, formKey);
        });
    }, [formColumns]);

    return <div className="create-new-customer-form-columns">{formColumns && formColumns.map(renderFormColumn)}</div>;
};

export default withTranslation()(CustomerForm);
